import { BotSpeedSettings, DiceSettingEnum, ExtensionSettingEnum, GameSpeedSettings, MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum } from '@colonist/types';
// maybe this should be in its own package
export class RoomSettingConstants {
}
RoomSettingConstants.MIN_VP_TO_WIN = 3;
RoomSettingConstants.DEFAULT_VP_TO_WIN = 10;
RoomSettingConstants.MIN_CARD_DISCARD_LIMIT = 5;
RoomSettingConstants.DEFAULT_CARD_DISCARD_LIMIT = 7;
RoomSettingConstants.MAX_CARD_DISCARD_LIMIT = 20;
RoomSettingConstants.MIN_PLAYER_COUNT = 1;
RoomSettingConstants.DEFAULT_PLAYER_COUNT = 4;
RoomSettingConstants.MAX_PLAYER_COUNT = 8;
RoomSettingConstants.DEFAULT_GAME_SPEED_SETTING = GameSpeedSettings.Base60s;
RoomSettingConstants.DEFAULT_BOT_SPEED_SETTING = BotSpeedSettings.Normal;
RoomSettingConstants.DEFAULT_HIDE_BANK_CARDS = false;
RoomSettingConstants.DEFAULT_FRIENDLY_ROBBER = false;
RoomSettingConstants.DEFAULT_MODE_SETTING = ModeSettingEnum.Classic4P;
RoomSettingConstants.DEFAULT_EXTENSION_SETTING = ExtensionSettingEnum.Players4;
RoomSettingConstants.DEFAULT_SCENARIO_SETTING = ScenarioSettingEnum.None;
RoomSettingConstants.DEFAULT_MAP_SETTING = MapSettingEnum.Classic4P;
RoomSettingConstants.DEFAULT_DICE_SETTING = DiceSettingEnum.Random;
RoomSettingConstants.DEFAULT_KARMA_THRESHOLD = 0;
RoomSettingConstants.NO_TROLLS_KARMA_THRESHOLD = 19;
